export default "__VITE_ASSET__CMnqFYNB__"